import { CommonService } from './../page/common.service';
import { TooltipService } from './../shared/tooltip/tooltip.service';
import { Component, OnInit, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { LateralPanelService } from '../page/lateral-panel/lateral-panel.service';
import { AnalyticsLibraryService } from '../analytics-library.service';

export const NAMESPACE_URIS: { [ns: string]: string } = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: "http://www.w3.org/1999/xhtml",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss","./spinner.component.responsive.scss"]
})
export class SpinnerComponent implements OnInit, AfterViewInit {
  @Input() title: string;
  @Input() description: string;
  @Input("value") spinnerValue: number = 0;
  @Input("min") spinnerMin: number = 0;
  @Input("max") spinnerMax: number = 100;
  @Input() tooltip: string;
  @Input() id: number;
  @Input() image: string = undefined;
  @Input() imageClassFromFrontEnd: string = undefined;
  @Input() lateralPanelId: string;
  @Input() showInfoButton: boolean=false;
  @Input() showTooltip: boolean=false;
  @Input() price: number = 0;
  @Input() showPrice: number = 0;
  @Input() included: boolean = false;
  @Input() lateralPanelTitle: string; //Lo uso per gli analitycs

  @Output() onSpinnerUpd = new EventEmitter();

  @Output() infoClicked = new EventEmitter();

  constructor(
    private ts: TooltipService,
    private cs: CommonService,
    private lps: LateralPanelService,
    private ap: AnalyticsLibraryService
  ) {}

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  private setSpinnerValue(value: number) {
    if (value >= this.spinnerMin && value <= this.spinnerMax) {
      this.spinnerValue = value;
      this.onSpinnerUpd.emit(this.spinnerValue);
    }
  }


  public onAdd() {
    this.setSpinnerValue(this.spinnerValue+1);
  }

  public onRemove() {
    this.setSpinnerValue(this.spinnerValue-1);
  }

  onInfoClick(event: Event) {
    this.ap.sendPageViewInfo(this.lateralPanelTitle);
    event.stopPropagation();
    if (this.lateralPanelId) this.lps.open(this.lateralPanelId);
    else this.infoClicked.next(this.id);
  }

}
